import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { LoadingActions } from 'actions'

export default class OpenTimeActions extends Actions{
    static get target(){
        return 'openTimes'
    }

    static fetch(){
        LoadingActions.append({openTimes: true})
        this.client.organizations.openTimes.fetch({organizationID: store.getState().config.organizationID}).then((response)=>{
            let data = response.data.reduce((acc, item)=>{
                acc[item.id] = item
                return acc
            }, {})
            LoadingActions.append({openTimes: false})
            this.set(data)
        })
    }
}


// WEBPACK FOOTER //
// ./actions/OpenTimeActions.js